import module from 'recursoshumanos/module.js'
import template from './template.html'

const diacriticosRegex = /[\u0300-\u036f]/g
const normalizar = (valor) => valor.normalize('NFD').replace(diacriticosRegex, '').toUpperCase()
const crearValidacion = (referencia, coincide, opcion) => {
  return {
    valido: coincide,
    mensaje: `${referencia} ${coincide ? 'coincide' : 'no coincide'} ${opcion}`,
  }
}
const validar = (registro, opcion) => {
  const coincideNombre = normalizar(registro.nombre) === normalizar(opcion.nombre)
  const coincideNss = registro.nss === opcion.nss
  const coincideSalario = registro.salario_base === opcion.salario_base
  const coincideEstatus = registro.estatus === opcion.estatus
  const movimientoExiste = opcion.id_movimiento !== null

  return {
    coincide: coincideSalario && coincideNombre && coincideNss && coincideEstatus,
    validaciones: {
      nombre: crearValidacion('El nombre del colaborador', coincideNombre, 'con el del registro'),
      nss: crearValidacion('El número de seguro social del colaborador', coincideNss, 'con el del registro'),
      salario: crearValidacion('El salario del colaborador', coincideSalario, 'con el del registro'),
      estatus: crearValidacion('El estatus del colaborador', coincideEstatus, 'con el tipo de movimiento del registro'),
      movimiento: {
        valido: movimientoExiste,
        mensaje: `${movimientoExiste ? 'Se' : 'No se'} encontró registro del movimiento en el sistema`,
      },
    },
  }
}

export class RecursoshumanosCargarmovimientosComponent {
  empresaId
  clase
  registroPatronalId
  datosFormados = undefined
  registro_patronal = null
  operadoras = []
  registros = []
  validos = []
  data = {
    id_empresa: null,
    clase: null,
    numero_lote: '',
    fecha_lote: '',
    registros: [],
  }

  constructor ($q, $location, $notify, $state, RecursosHumanosLotesIMSSCoincidencias) {
    this.$q = $q
    this.$notify = $notify
    this.$state = $state
    this.$location = $location
    this.RecursosHumanosLotesIMSSCoincidencias = RecursosHumanosLotesIMSSCoincidencias
  }

  configurar ({empresaId, clase, registroPatronalId}) {
    if (this.empresaId !== empresaId) {
      this.empresaId = empresaId
      this.buscarCoincidencias()
    }
    this.clase = clase
    this.registroPatronalId = registroPatronalId
    this.$location.replace()
    this.$location.search({empresaId, clase, registroPatronalId})
  }

  borrar () {
    this.datosFormados = this.resultados = this.seleccionados = null
  }

  buscarCoincidencias () {
    if (this.buscando) return
    if (!Array.isArray(this.datosFormados) || !this.datosFormados.length) return

    this.buscando = true
    this.resultados = null

    let registros = this.datosFormados
      .map((item) => ({indice: item.indice, nombre: item.registro.nombre, nss: item.registro.nss, tipo_movimiento: item.registro.tipo_movimiento}))

    this.RecursosHumanosLotesIMSSCoincidencias.get(this.empresaId, registros)
      .then(({data}) => (this.relacionar(data)))
      .finally(() => (this.buscando = false))
  }

  cerrar (data) {
    this.modal = false

    if (data) {
      this.$state.reload()
    }
  }

  procesar ({data}) {
    let seleccionado = null
    let resultados = null
    this.datosFormados = data.map((registro, indice) => ({indice, registro, seleccionado, resultados}))

    this.buscarCoincidencias()
  }

  relacionar (movimientos) {
    this.datosFormados.forEach((item) => {
      const movimiento = movimientos.find((movimiento) => movimiento.indice === item.indice)

      item.resultados = ((movimiento && movimiento.resultados) || [])
        .map((resultado) => Object.assign(resultado, validar(item.registro, resultado)))

      if (item.seleccionado) {
        item.seleccionado = item.resultados.find((opcion) => opcion.id_proyecto === item.seleccionado.id_proyecto && opcion.id_colaborador === item.seleccionado.id_colaborador) || null
      }

      if (!item.seleccionado) {
        let coincidencias = item.resultados.filter((opcion) => opcion.coincide)
        if (coincidencias.length === 1) {
          item.seleccionado = coincidencias[0]
        }
      }
    })

    this.seleccionarValidos()
  }

  seleccionarValidos () {
    this.validos = this.datosFormados.filter((item) => item.seleccionado)
  }

  subirMovimientos () {
    if (this.validos.length !== this.datosFormados.length) return
    this.data.id_empresa = this.empresaId
    this.data.clase = this.clase
    this.data.registroPatronalId = this.registroPatronalId
    this.data.registros = this.datosFormados
    this.modal = true
  }
}

module.component('recursoshumanosCargarmovimientos', {
  controller: RecursoshumanosCargarmovimientosComponent,
  template,
  bindings: {
    empresaId: '<',
    clase: '<',
    registroPatronalId: '<',
  },
})



// WEBPACK FOOTER //
// ./src/recursoshumanos/components/cargarmovimientos/component.js